import { string } from "zod";

export const disciplineArray = [
    "C10",
    "P10",
    "C300",
    "P25",
    "P50",
    "C50"
] as const

export type discipline = typeof disciplineArray[number]

export enum cible {
    C_A5,
    C_A10,
    C_A20,
    C_A100,
    C_A109,
    C_B4,
    C_B10,
    C_B100,

}

export enum weapon {
    F90 = "F90",
    F57_03 = "F57_03",
    F57_02 = "F57_02",
    K31 = "K31",
    FS = "FS",
    FL = "FL",
    PSPC = "PSPC",
    PO = "PO",
    P = "PS"
}

export type ApiResponse<T> = {
    success: boolean;
    data?: T;
    error?: string;
}

export type loginPayload = {
    license: string;
    password: string;
}

export type loginResponse = {
    token: string
}

export type registerData = {
    license: string;
    email: string;
    password: string;
    confirmPassword: string;
    firstname: string;
    lastname: string;
    birthdate: string;
}

export type updateUserData = {
    license?: string;
    email?: string;
    firstname?: string;
    lastname?: string;
    birthdate?: string;
    address?: string;
    city?: string;
    canton?: string;
    phone?: string;
    zipCode?: string;
    password?: string;
} 

export type shooter = {
    email?: string;
    firstname?: string;
    lastname?: string;
    birthdate?: string;
    address?: string;
    city?: string;
    canton?: string;
    phone?: string;
    zipCode?: string;
    password?: string;
    id:string;
    user:{
        id:string
    }
    
}

export type societe = {
    id: string;
    no_ssv?: string;
    adresse?: string;
    canton?: string;
    email_contact?: string;
    localite?: string;
    nom?: string;
    npa?: string;
    prefix?: string;
    disciplines?: discipline[];
    events?: events[];
    membres_societes?: shooter[];
    roles_comptes?: roles[];
}

export type events = {
    id: string;
}

export type roles = {
    accoutn_id: string;
    permission: number;
    societe_id: string;
}

export type roundDataInput = {
    name?: string
    date?: string;
    result?: string;
    numberShots?: string;
    discipline?: string;
    weapon?: string;
    visuel?: string;
    appuis?:  boolean;
    position?: string[];
}

export type recievedRoundData = {
    dateTir: string,
    disciplineId: string,
    event: {name:string} | null,
    id:string,
    name:string,
    numberShot: number,
    series: string | null
    societe: societe | null,
    total:number,
    appuis: boolean,
    position: string[],
    visuel: {
        name:string,
        id:string,
        point:number
    } | null,
    weaponId: string,
}

export type apiFastRoundData = {
    name?: string
    date?: Date;
    result?: number;
    numberShots?: number;
    discipline?: string;
    weapon?: string;
    visuel?: string;
    appuis?:  boolean;
    position?: string[];
}

export type roundSchemaInfo = {
    id: string;
    name: string;
    numberShots: number;
    discipline?: discipline;
}

export type roundSerie = {
    serieType: typeof roundSerieType[number],
    numberShots: number,
    targetId: string,
    position: typeof position[number]
    targetName?: string;
}

export const position = [
    "PRONE",
    "KNEELING",
    "STANDING"
]as const

export const roundSerieType = [
    "PROBE",
    "EINZEL",
    "SERIE"
] as const